// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-k_gC","advertDetailContactGroup__header":"c-k_gE","advertDetailContactGroup__value":"c-k_gF"};